import Navbar from '../../Laboratorio/NavbarLaboratorio/navbarlaboratorio';
import React from 'react';
import '../Ensaios/teoragua.css';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';



function TeorDeAgua() {
  const [massaumida1, setMassaumida1] = useState()
  const [massaumida2, setMassaumida2] = useState()
  const [massaumida3, setMassaumida3] = useState()
  const [massaumida4, setMassaumida4] = useState()


  const [massaseca1, setMassaSeca1] = useState()
  const [massaseca2, setMassaSeca2] = useState()
  const [massaseca3, setMassaSeca3] = useState()
  const [massaseca4, setMassaSeca4] = useState()


  const [massacapsula1, setMassaCapsula1] = useState()
  const [massacapsula2, setMassaCapsula2] = useState()
  const [massacapsula3, setMassaCapsula3] = useState()
  const [massacapsula4, setMassaCapsula4] = useState()


  const [massaagua1, setMassaagua1] = useState()
  const [massaagua2, setMassaagua2] = useState()
  const [massaagua3, setMassaagua3] = useState()
  const [massaagua4, setMassaagua4] = useState()


  const [massasoloseca1, setMassaSoloSeca1] = useState()
  const [massasoloseca2, setMassaSoloSeca2] = useState()
  const [massasoloseca3, setMassaSoloSeca3] = useState()
  const [massasoloseca4, setMassaSoloSeca4] = useState()

  const [teoragua1, setTeorAgua1] = useState()



  const [media, setMedia] = useState()

  const ateoragua1 = (massaagua1 / massasoloseca1 * 100)

  const ateoragua2 = (massaagua2 / massasoloseca2 * 100)
  const ateoragua3 = (massaagua3 / massasoloseca3 * 100)
  const ateoragua4 = (massaagua4 / massasoloseca4 * 100)

  const desviorelativo1 = (ateoragua1 - media)
  const desviorelativo2 = (ateoragua2 - media)
  const desviorelativo3 = (ateoragua3 - media)
  const desviorelativo4 = (ateoragua4 - media)

  const [auxteoragua1, setAuxteoragua1] = useState(ateoragua1);
  const [auxteoragua2, setAuxteoragua2] = useState(ateoragua2);
  const [auxteoragua3, setAuxteoragua3] = useState(ateoragua3);
  const [auxteoragua4, setAuxteoragua4] = useState(ateoragua4);


  useEffect(() => {
    setAuxteoragua1(ateoragua1)
    setAuxteoragua2(ateoragua2)
    setAuxteoragua3(ateoragua3)
    setAuxteoragua4(ateoragua4)
  })

  //   }

  const auxteoragua1Change = (event) => {
    // setAuxteoragua1(event.target.value);
    calcularMedia(event, auxteoragua2, auxteoragua3, auxteoragua4);
  };

  const auxteoragua2Change = (event) => {
    // setAuxteoragua2(event.target.value);
    calcularMedia(event, auxteoragua1, auxteoragua3, auxteoragua4);
  };

  const auxteoragua3Change = (event) => {
    // setAuxteoragua3(event.target.value);
    calcularMedia(event, auxteoragua1, auxteoragua2, auxteoragua4);
  };

  const auxteoragua4Change = (event) => {
    // setAuxteoragua3(event.target.value);
    calcularMedia(event, auxteoragua1, auxteoragua2, auxteoragua3);
  };

  const calcularMedia = (auxteoragua1, auxteoragua2, auxteoragua3, auxteoragua4) => {
    let soma = 0;
    let contador = 0;




    if (auxteoragua1) {
      soma += Number(auxteoragua1);
      contador++;
    }

    if (auxteoragua2) {
      soma += Number(auxteoragua2);
      contador++;
    }

    if (auxteoragua3) {
      soma += Number(auxteoragua3);
      contador++;
    }

    if (auxteoragua4) {
      soma += Number(auxteoragua4);
      contador++;
    }

    else {
      contador = contador || 2;
    }

    const resultado = soma / contador;
    setMedia(resultado.toFixed(2));
  };

  const atmassaaguasub1 = (novoValorSub1) => {
    setMassaumida1(novoValorSub1)

  }
  const attmassaaguasub = (novoValorSub) => {

    setMassaSeca1(novoValorSub);
    setMassaagua1(massaumida1 - novoValorSub);

  }

  const atmassaaguasub2 = (novoValorSub1) => {
    setMassaumida2(novoValorSub1)

  }
  const attmassaaguasub1 = (novoValorSub) => {

    setMassaSeca2(novoValorSub);
    setMassaagua2(massaumida2 - novoValorSub);

  }

  const atmassaaguasub3 = (novoValorSub1) => {
    setMassaumida3(novoValorSub1)

  }
  const attmassaaguasub2 = (novoValorSub) => {

    setMassaSeca3(novoValorSub);
    setMassaagua3(massaumida3 - novoValorSub);

  }

  const atmassaaguasub4 = (novoValorSub1) => {
    setMassaumida4(novoValorSub1)
  }
  const attmassaaguasub3 = (novoValorSub) => {

    setMassaSeca4(novoValorSub);
    setMassaagua4(massaumida4 - novoValorSub);

  }

  const atualizarValorSub1 = (novoValorSub1) => {
    setMassaSeca1(novoValorSub1)

  }
  const attualizarValorSub = (novoValorSub) => {

    setMassaCapsula1(novoValorSub);
    setMassaSoloSeca1(massaseca1 - novoValorSub);
  }

  const atualizarValorSub2 = (novoValorSub1) => {
    setMassaSeca2(novoValorSub1)

  }
  const attualizarValorSub1 = (novoValorSub) => {

    setMassaCapsula2(novoValorSub);
    setMassaSoloSeca2(massaseca2 - novoValorSub);
  }

  const atualizarValorSub3 = (novoValorSub1) => {
    setMassaSeca3(novoValorSub1)

  }
  const attualizarValorSub2 = (novoValorSub) => {

    setMassaCapsula3(novoValorSub);
    setMassaSoloSeca3(massaseca3 - novoValorSub);
  }

  const atualizarValorSub4 = (novoValorSub1) => {
    setMassaSeca4(novoValorSub1)

  }
  const attualizarValorSub3 = (novoValorSub) => {

    setMassaCapsula4(novoValorSub);
    setMassaSoloSeca4(massaseca4 - novoValorSub);
  }

  useEffect(() => {
    auxteoragua1Change(auxteoragua1)
    auxteoragua2Change(auxteoragua2)
    // auxteoragua3Change(auxteoragua3)
    // auxteoragua4Change(auxteoragua4)
  },
    [auxteoragua1][auxteoragua2]
    //  [auxteoragua3]
    //  [auxteoragua4]
  );

  useEffect(() => {

    auxteoragua3Change(auxteoragua3)
    auxteoragua4Change(auxteoragua4)
  },

    [auxteoragua3]
    [auxteoragua4]
  );



  return <div>
    <Navbar />
    <h1 className='titulo1'>DETERMINAÇÃO DO TEOR DE ÁGUA</h1>

    <div className="d-flex justify-content-center mt-5">
      <div className="row">
        <div className="col-4">
          <div className="input-group mb-3">
            <input type="text" className="form-control" placeholder="Pesquisar Amostra" aria-describedby="button-addon2" />
          </div>
        </div>
        <div className="col-4">
          <div className="input-group mb-3">
            <input type="text" className="form-control" placeholder="Número" aria-describedby="button-addon2" />
          </div>
        </div>
        <div className="col-4">
          <div className="input-group mb-3">
            <button className="btnnavintacta" type="button" id="button-addon2" >Pesquisar</button>
          </div>
        </div>
      </div>
    </div>



    <div className="d-flex justify-content-between mt-3" style={{ marginLeft: '30%', marginTop: '100%' }}>
      <div className="d-flex align-items-start">
        <div className="d-flex flex-column align-items-start mr-3">
          <h4>Cadastro de Equipamentos</h4>
          <div className="w-60 mt-3">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" style={{ width: '200px' }}>
              Balança
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item" href="#">Action</a></li>
              <li><a class="dropdown-item" href="#">Another action</a></li>
              <li><a class="dropdown-item" href="#">Something else here</a></li>
            </ul>
          </div>

          <div className="w-60 mt-3">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" style={{ width: '200px' }}>


              Estufa
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item" href="#">Action</a></li>
              <li><a class="dropdown-item" href="#">Another action</a></li>
              <li><a class="dropdown-item" href="#">Something else here</a></li>
            </ul>
          </div>
        </div>

        <div className="d-flex flex-column" style={{ marginLeft: '10%' }}>
          <div className="d-flex flex-column align-items-start mr-4">
            <h4>Norma de Ensaio:</h4>
            <input type="text" className="form-control" style={{ marginTop: '8%' }} placeholder="Norma de ensaio" />
          </div>


        </div>
        <div className="d-flex flex-column" style={{ marginLeft: '10%' }}>
          <div className="d-flex flex-column align-items-start" style={{ paddingTop: '15%' }}>
            <h4 className="mt-3">Laboratório:</h4>
            <input type="text" className="form-control" />
          </div>
        </div>
      </div>
    </div>
  </div>
}
export default TeorDeAgua;